"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var BlDropdown_1 = __importDefault(require("../../BlDropdown"));
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var searchParamsSlice_1 = require("../../../../features/searchParams/searchParamsSlice");
var isArray_1 = __importDefault(require("lodash/isArray"));
var classnames_1 = __importDefault(require("classnames"));
var styles_module_scss_1 = __importDefault(require("../StateChoice/styles.module.scss"));
var DistrictChoice = function (_a) {
    var defaultValue = _a.defaultValue, handleStateDistrictChange = _a.handleStateDistrictChange, handleChangeSelectedDistrict = _a.handleChangeSelectedDistrict, currentLanguage = _a.currentLanguage;
    var t = react_i18next_1.useTranslation('common').t;
    var dispatch = react_redux_1.useDispatch();
    var selectedDistricts = react_redux_1.useSelector(searchParamsSlice_1.useSelectSelectedDistrictsData);
    var toggleLoading = react_redux_1.useSelector(searchParamsSlice_1.useSelectToggleLoadingStateData);
    var _b = react_1.useState(selectedDistricts), districtsData = _b[0], setDistrictData = _b[1];
    var _c = react_1.useState(), selectedDistrict = _c[0], setSelectedDistrict = _c[1];
    react_1.useEffect(function () {
        return function () {
            dispatch(searchParamsSlice_1.removeSelectedAllDistricts());
        };
    }, []);
    // @TODO this data {filtering} added temporary, need to fix geometry coordinates!
    react_1.useEffect(function () {
        if (selectedDistricts.length) {
            var filteredData = selectedDistricts.filter(function (item) {
                if (item.geometry.coordinates &&
                    isArray_1.default(item.geometry.coordinates[0])) {
                    return item;
                }
            });
            setDistrictData(filteredData);
        }
    }, [selectedDistricts]);
    react_1.useEffect(function () {
        if (defaultValue && districtsData.length) {
            var selectedDistrict_1 = districtsData.find(function (item) { return item.govId === Number(defaultValue); });
            setSelectedDistrict(selectedDistrict_1);
        }
    }, [defaultValue, districtsData]);
    react_1.useEffect(function () {
        if (selectedDistrict) {
            handleStateDistrictChange(selectedDistrict, 'districtId', 'district');
            handleChangeSelectedDistrict(selectedDistrict);
        }
        else {
            handleChangeSelectedDistrict(null);
        }
    }, [selectedDistrict]);
    var handleChange = function (data) {
        var selectedDistrict = districtsData.find(function (item) { return item.text === data.value; });
        setSelectedDistrict(selectedDistrict);
    };
    return (react_1.default.createElement("div", { className: classnames_1.default('field required', styles_module_scss_1.default.district) },
        react_1.default.createElement("label", { htmlFor: "district" }, t('fields.section3.district')),
        react_1.default.createElement(BlDropdown_1.default, { value: (selectedDistrict === null || selectedDistrict === void 0 ? void 0 : selectedDistrict.text) || '', options: districtsData.map(function (item, index) {
                var _a;
                return ({
                    key: index,
                    value: item.text,
                    text: (_a = item.translations[currentLanguage]) !== null && _a !== void 0 ? _a : item.text,
                });
            }), className: styles_module_scss_1.default.dropdown, selection: true, placeholder: t('ADDRESS_PICKER.DISTRICT'), name: "district", disabled: !districtsData.length || toggleLoading, selectOnBlur: false, onChange: function (event, data) { return handleChange(data); } })));
};
exports.default = DistrictChoice;
